import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, createFidesTheme } from '@fides/fides-react-components';

import App from './App';
import ErrorBoundary from './app/components/layout/ErrorBoundary/ErrorBoundary';
import { AppStartup } from './AppStartup';
import './i18n';
import './index.css';
import * as serviceWorker from './serviceWorker';
import SnackbarProvider from "./app/providers/SnackbarProvider";

// Listening on browser bfCache and force a reload if the user has logged out.
const preventHistoryBackLoggedOut = (event: any) => {
  if (event.persisted && !document.cookie.includes('jwtAccessToken')) {
    window.location.reload();
  }
};

let isGlobalListenerAttached = false;
if (!isGlobalListenerAttached) {
  window.addEventListener('pageshow', preventHistoryBackLoggedOut);
  isGlobalListenerAttached = true;
}

const theme = createFidesTheme();

ReactDOM.render(
  <ErrorBoundary>
    <ThemeProvider theme={
      theme
    }>
      <SnackbarProvider>
        <AppStartup>
          <App />
        </AppStartup>
      </SnackbarProvider>
    </ThemeProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
